/** @jsxImportSource @emotion/react */
import React from "react";

import { useTranslation } from "react-i18next";

import { CREDIT_BEHAVIOUR_COLUMNS } from "@/Pages/Dashboard/LeftSide/types";
import { Typography } from "@mui/material";
import MuiTableCell from "@mui/material/TableCell";
import MuiTableHead from "@mui/material/TableHead";
import MuiTableRow from "@mui/material/TableRow";

interface CreditTableHeadProps {
  columns: CREDIT_BEHAVIOUR_COLUMNS[];
}

const CreditTableHead = ({ columns }: CreditTableHeadProps) => {
  const { t } = useTranslation();

  return (
    <MuiTableHead data-testid="credit-behaviour-table-head">
      <MuiTableRow>
        {columns.map((name: CREDIT_BEHAVIOUR_COLUMNS) => {
          return (
            <MuiTableCell
              key={name}
              style={{
                borderBottom: "none",
                boxShadow: "0 -1px 0 0 #C5E2FF inset"
              }}
            >
              <Typography variant="body3Medium">
                {t(
                  `Dashboard##how credits work##bottom content##table##head##${name}`
                )}
              </Typography>
            </MuiTableCell>
          );
        })}
      </MuiTableRow>
    </MuiTableHead>
  );
};

export default React.memo(CreditTableHead);
